module.exports = __webpack_public_path__ + "img/oufu_78x104x11.prt.b8b7ce99.jpg";